<template>
  <b-overlay
    id="overlay-background"
    :show="filterLoader === true"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-card
      no-body
      class="card-payment"
    >
      <b-card-body>
        <!-- form -->
        <b-form>
          <validation-observer
            ref="filterFormObserver"
          >
            <b-row>
              <b-col
                md="6"
                lg="6"
              >
                <b-row>
                  <b-col sm="12">
                    <b-form-group
                      :label="$t('DEBTIA_TYPE')"
                      label-for="type"
                    >
                      <b-form-input
                        id="title"
                        v-model="filterListValues.type"
                        type="text"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Roles"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_ROLES')"
                        label-for="roles"
                      >
                        <v-select
                          v-model="filterListValues.roles"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="noteRoles"
                          :reduce="val => val.value"
                          :clearable="false"
                          multiple
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Title"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_TITLE')"
                        label-for="title"
                      >
                        <b-form-input
                          id="title"
                          v-model="filterListValues.title"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          :placeholder="$t('DEBTIA_TITLE')"
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Filters"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_FILTER')"
                        label-for="filters"
                      >
                        <v-select
                          v-if="filterListValues.type"
                          id="filters"
                          v-model="filters"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :reduce="val => val.value"
                          multiple
                          label="label"
                          :options="filterOptions"
                          @option:deselected="filterChange($event, 0)"
                          @option:selected="filterChange($event, 1)"
                        />
                        <b-form-input
                          v-else
                          id="title"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          placeholder="Select Type First."
                          readonly
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                md="6"
                lg="6"
              >
                <b-row>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Description"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DESCRIPTION')"
                        label-for="description"
                      >
                        <b-form-textarea
                          id="description"
                          v-model="filterListValues.description"
                          :placeholder="$t('DEBTIA_DESCRIPTION')"
                          rows="8"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="List Columns"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_LIST_COLUMNS')"
                        label-for="list-columns"
                      >
                        <v-select
                          v-if="filterListValues.type"
                          v-model="filterListValues.columns"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="listColumnOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="columns"
                          multiple
                        >
                          <template
                            #selected-option-container="{ option }"
                          >
                            <div class="vs__selected">
                              {{ $t(option.label) }}
                              <button
                                v-if="option.value !== 'id'"
                                type="button"
                                class="vs__deselect"
                                @click="deselectcolumn(option.value)"
                              >
                                <feather-icon
                                  icon="XIcon"
                                  size="18"
                                />
                              </button>
                            </div>
                          </template>
                          <template
                            slot="option"
                            slot-scope="option"
                          >
                            {{ $t(option.label) }}
                          </template>
                        </v-select>
                        <b-form-input
                          v-else
                          id="title"
                          :state="errors.length > 0 ? false:null"
                          type="text"
                          placeholder="Select Type First."
                          readonly
                          trim
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <case-filters
              v-if="filterListValues.type === 'case'"
              ref="case-filters-component"
              :filter-value="filterValue"
              :filter-bit="filterBit"
              :filter-details="filterDetails"
              :filter-id="filterId"
            />
            <client-filters
              v-if="filterListValues.type === 'client'"
              ref="client-filters-component"
              :filter-value="filterValue"
              :filter-bit="filterBit"
              :filter-details="filterDetails"
              :filter-id="filterId"
            />
            <debtor-filters
              v-if="filterListValues.type === 'debtor'"
              ref="debtor-filters-component"
              :filter-value="filterValue"
              :filter-bit="filterBit"
              :filter-details="filterDetails"
              :filter-id="filterId"
            />
          </validation-observer>
          <!-- Action Buttons -->
          <hr v-if="filterListValues.type">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mr-1"
            @click="saveFilter"
          >
            {{ $t('DEBTIA_UPDATE') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-danger"
            class="mr-1"
            @click="goBack"
          >
            {{ $t('DEBTIA_CANCEL') }}
          </b-button>
        </b-form>
        <!--/ form -->
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BForm, BFormInput, BOverlay, BFormTextarea, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
// import store from '@/store/index'
// import i18n from '@/libs/i18n'
import generalVars from '@/general-vars'
import CaseFilters from './CaseFilters.vue'
import ClientFilters from './ClientFilters.vue'
import DebtorFilters from './DebtorFilters.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BOverlay,
    BFormTextarea,
    DebtorFilters,
    ClientFilters,
    CaseFilters,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    // settings: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
      filterLoader: false,
      required,
      typeOptions: [
        { label: 'Case', value: 'case' },
        { label: 'Client', value: 'client' },
        { label: 'Debtor', value: 'debtor' },
      ],
      filterListValues: {
        roles: [],
        title: '',
        description: '',
        type: '',
        filter: {},
        columns: ['id'],
      },
      filters: [],
      changeBit: false,
      generalVars,
      filterOptions: [],
      listColumnOptions: [],
      noteRoles: [],
      filterValue: '',
      filterBit: false,
      filterDetails: {},
      filterId: null,
    }
  },
  watch: {
  },
  created() {
    this.getFilterDetatils()
    this.getRoles()
  },
  methods: {
    deselectcolumn(id) {
      this.filterListValues.columns.splice(this.filterListValues.columns.indexOf(id), 1)
    },
    goBack() {
      this.$router.push('/filter-list')
    },
    getFilterDetatils() {
      this.filterLoader = true
      this.filterId = Number(this.$route.params.id)
      const url = `/get-filter-list?filter_list_id=${this.filterId}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.filterListValues = response.data.data.data
          this.typechanged(this.filterListValues.type)
          this.filters = Object.keys(this.filterListValues.filter)
          this.filterDetails = this.filterListValues.filter
          // eslint-disable-next-line no-return-assign
          setTimeout(() => this.filterLoader = false, 5000)
        }
      })
    },
    saveFilter(evt) {
      evt.preventDefault()
      this.$refs.filterFormObserver.validate().then(success => {
        if (success) {
          this.filterLoader = true
          this.filterListValues.filter = this.getFilter()
          this.filterListValues.filter_id = this.filterId
          this.filterListValues.filter_list_id = this.filterListValues.filter_id
          axios.post('/edit-filter-list', this.filterListValues).then(responseLocal => {
            if (responseLocal.status) {
              this.filterLoader = false
              this.makeSuccessToast()
              this.$router.push('/filter-list')
            }
          }).catch(err => {
            this.makeFailureToast(err)
            this.filterLoader = false
          })
        } else {
          // reject()
        }
      })
    },
    getFilter() {
      let values = ''
      if (this.filterListValues.type === 'case') {
        values = this.$refs['case-filters-component'].caseFiltersValues
      }
      if (this.filterListValues.type === 'client') {
        values = this.$refs['client-filters-component'].clientFiltersValues
      }
      if (this.filterListValues.type === 'debtor') {
        values = this.$refs['debtor-filters-component'].debtorFiltersValues
      }
      const processObject = {}
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.filters.length; i++) {
        processObject[this.filters[i]] = values[this.filters[i]]
      }
      values = processObject
      return values
    },
    typechanged(event) {
      if (event === 'case') {
        this.filterOptions = generalVars.caseFilters
        this.listColumnOptions = generalVars.caseColumns
      } else if (event === 'client') {
        this.filterOptions = generalVars.clientFilters
        this.listColumnOptions = generalVars.clientColumns
      } else {
        this.filterOptions = generalVars.debtorFilters
        this.listColumnOptions = generalVars.debtorColumns
      }
    },
    filterChange(event, added) {
      this.changeBit = !this.changeBit
      if (added) {
        this.filterValue = event[event.length - 1].value
      } else {
        this.filterValue = event.value
      }
      this.filterBit = !this.filterBit
    },
    getRoles() {
      axios.get('/users/get-user-roles-dropdown').then(response => {
        if (response.status === 200) {
          this.noteRoles = response.data.data
        }
      })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Filter has been successfully created', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.margin-btm-1 {
  padding: 5px 0px 5px 0px;
}

.filter-heading {
  border-top: 1px solid #d8d6de;
  padding-top: 15px;
  margin-top: 10px;
}
</style>
